// src/components/dashboard/menucontent/Assessments.tsx

import React, { useEffect, useState } from "react";
import serviceApi from "../../../services/serviceApi";
import environment from "../../../environments/environment";

interface AssessmentItem {
    title: string;
    year: string;
    url: string;
}

const Assessments: React.FC = () => {
    const [dataList, setDataList] = useState<AssessmentItem[]>([]);
    const [year, setYear] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(true);
    const [selectedImage, setSelectedImage] = useState<string>("");

    const academic = [
        { year: "2024-2025" },
        { year: "2023-2024" },
        { year: "2022-2023" },
        { year: "2021-2022" },
    ];

    useEffect(() => {
        loadAssessments();
    }, []);

    const loadAssessments = async () => {
        try {
            const response = await serviceApi.get(environment.assessments);
            if (response?.data?.objectData?.assessments) {
                setDataList(response.data.objectData.assessments);
            }
        } catch (error) {
            console.error("Error loading assessments:", error);
        } finally {
            setLoading(false);
        }
    };

    const filteredData = year === "" ? dataList : dataList.filter((item) => item.year === year);

    return (
        <>
            <div className="contentsav mt-1 fixed-bg-screen bg-assessments">
                <div className="row no-margin no-padding content-bg dangerColor">
                    <div
                        className="col-12"
                        style={{
                            position: "relative",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginBottom: "15px",
                            paddingTop: "10px",
                        }}
                    >
                        <div
                            className="title-text"
                            style={{
                                marginBottom: "0",
                                textAlign: "center",
                                fontSize: "20px",
                            }}
                        >
                            Assessments
                        </div>
                        <div
                            style={{
                                position: "absolute",
                                right: "10px",
                                width: "180px",
                            }}
                        >
                            <select
                                value={year}
                                onChange={(e) => setYear(e.target.value)}
                                className="filter-subject-dropdown"
                                style={{
                                    width: "100%",
                                    background: "#fff",
                                }}
                            >
                                <option value="">Select Year</option>

                                {academic.map((item, index) => (
                                    <option key={index} value={item.year}>
                                        {item.year}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    {loading && (
                        <div className="loading-screen">
                            <div className="spinner spinner--md"></div>
                            <div className="loading-text">
                                Loading Assessments...
                            </div>
                        </div>
                    )}
                    {!loading &&
                        filteredData.map((g1, index) => (
                            <div
                                key={index}
                                className="no-margin no-padding col-6 col-sm-4 col-md-3 col-lg-2 text-center pad10"
                            >
                                <div
                                    className="event-container"
                                    style={{
                                        cursor: "pointer",
                                        margin: "0",
                                        padding: "12px",
                                        minHeight: "90px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                    onClick={() => setSelectedImage(g1.url)}
                                >
                                    <div className="col-12 text-center">
                                        <div
                                            className="title-text"
                                            style={{
                                                fontSize: "14px",
                                                marginBottom: "5px",
                                                wordBreak: "break-word",
                                            }}
                                        >
                                            {g1.title}
                                        </div>

                                        <div className="subtitle-text">
                                            {g1.year}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                </div>
            </div>
            {selectedImage && (
                <div
                    className="popup-overlay"
                    onClick={() => setSelectedImage("")}
                >
                    <div
                        className="popup-box attachment-popup"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="popup-header">
                            <h3>Assessment</h3>

                            <button
                                className="close-popup-btn"
                                onClick={() => setSelectedImage("")}
                            >
                                ×
                            </button>
                        </div>
                        <div className="attachment-popup-content">
                            <img
                                src={selectedImage}
                                alt="Assessment"
                                className="attachment-image"
                            />
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Assessments;